export const getHybridMapStyles = (key: string, awsRegion: string) => ({
  version: 8,
  name: 'AmazonLocation-Hybrid-Global-Light-Default',
  metadata: {
    version: '2.1.0',
  },
  sources: {
    aws: {
      attribution:
        '© <a href=\'https://docs.aws.amazon.com/location/latest/developerguide/data-attribution.html\'>AWS</a>, <a href=\'https://legal.here.com/en-gb/terms/general-content-supplier-terms-and-notices\'>HERE</a>',
      maxzoom: 17,
      minzoom: 0,
      tiles: [
        `https://maps.geo.${awsRegion}.amazonaws.com/v2/tiles/vector.basemap/{z}/{x}/{y}?key=${key}`,
      ],
      type: 'vector',
    },
    awsImagery: {
      attribution:
        '© <a href=\'https://docs.aws.amazon.com/location/latest/developerguide/data-attribution.html\'>AWS</a>, <a href=\'https://legal.here.com/en-gb/terms/general-content-supplier-terms-and-notices\'>HERE</a>',
      maxzoom: 19,
      tiles: [
        `https://maps.geo.${awsRegion}.amazonaws.com/v2/tiles/raster.satellite/{z}/{x}/{y}?key=${key}`,
      ],
      type: 'raster',
    },
  },
  sprite: `https://maps.geo.${awsRegion}.amazonaws.com/v2/styles/2_1_0/Hybrid/Light/Default/sprites/sprites`,
  glyphs: `https://maps.geo.${awsRegion}.amazonaws.com/v2/glyphs/{fontstack}/{range}.pbf`,
  layers: [
    {
      id: 'land',
      paint: {
        'background-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(0, 0%, 100%)',
          15,
          'hsl(0, 0%, 80%)',
        ],
        'background-opacity': 0.1,
      },
      type: 'background',
    },
    {
      id: 'awsSatellite',
      paint: {
        'raster-contrast': 0.05,
        'raster-opacity': 0.9,
        'raster-saturation': 0.15,
      },
      source: 'awsImagery',
      type: 'raster',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
        ['has', 'is_tunnel'],
        ['!', ['has', 'service']],
        [
          'case',
          [
            'all',
            ['has', 'kind_detail'],
            ['==', ['get', 'kind_detail'], 'disused'],
          ],
          false,
          true,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'rail_tunnel',
      layout: {
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': 'hsl(180, 8%, 53%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          1,
          17,
          1.5,
          20,
          2,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'country'],
        ['==', ['to-number', ['get', 'kind_detail']], 2],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_country-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 1,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          'hsla(0, 0%, 0%, 0)',
          4,
          'hsl(0, 0%, 80%)',
          6,
          'hsl(0, 0%, 90%)',
        ],
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.3],
          ['zoom'],
          1,
          0.5,
          6,
          3,
          15,
          5,
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.3],
          ['zoom'],
          1,
          0.5,
          6,
          0.75,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind'], ['region', 'macroregion'], true, false],
        ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_region',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 2,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          'hsl(0, 0%, 35%)',
          4,
          'hsl(0, 0%, 35%)',
          6,
          'hsl(0, 0%, 35%)',
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          1,
          6,
          1.5,
          15,
          3,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'country'],
        ['==', ['to-number', ['get', 'kind_detail']], 2],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_country',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 1,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          1,
          'hsl(218, 20%, 22%)',
          13,
          'hsl(218, 5%, 22%)',
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.3],
          ['zoom'],
          1,
          0.5,
          6,
          3,
          15,
          5,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          [
            'disputed',
            'disputed_claim',
            'disputed_reference_line',
            'line_of_control',
            'indefinite',
            'indeterminate',
            'lease_limit',
          ],
          true,
          false,
        ],
        ['!=', ['get', 'kind'], 'unrecognized_disputed'],
        ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_region-disputed-mask',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 1,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(0, 0%, 100%)',
          15,
          'hsl(0, 0%, 80%)',
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          1,
          6,
          1.5,
          15,
          3,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          [
            'disputed',
            'disputed_claim',
            'disputed_reference_line',
            'line_of_control',
            'indefinite',
            'indeterminate',
            'lease_limit',
          ],
          true,
          false,
        ],
        ['!=', ['get', 'kind'], 'unrecognized_disputed'],
        ['match', ['to-number', ['get', 'kind_detail']], [3, 4], true, false],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_region-disputed',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 2,
      paint: {
        'line-color': 'hsl(0, 0%, 20%)',
        'line-dasharray': [1, 2.5],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          1,
          6,
          1.5,
          15,
          3,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          [
            'disputed',
            'disputed_claim',
            'disputed_reference_line',
            'line_of_control',
            'indefinite',
            'indeterminate',
            'lease_limit',
          ],
          true,
          false,
        ],
        ['!=', ['get', 'kind'], 'unrecognized_disputed'],
        ['==', ['to-number', ['get', 'kind_detail']], 2],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_country-disputed-mask',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 1,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          2,
          'hsla(0, 0%, 0%, 0)',
          4,
          'hsl(0, 0%, 80%)',
          6,
          'hsl(0, 0%, 90%)',
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 4, 1, 6, 0.7],
        'line-width': [
          'interpolate',
          ['exponential', 1.3],
          ['zoom'],
          1,
          2,
          6,
          3.75,
          10,
          3.75,
          20,
          5.75,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          [
            'disputed',
            'disputed_claim',
            'disputed_reference_line',
            'line_of_control',
            'indefinite',
            'indeterminate',
            'lease_limit',
          ],
          true,
          false,
        ],
        ['!=', ['get', 'kind'], 'unrecognized_disputed'],
        ['==', ['to-number', ['get', 'kind_detail']], 2],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'admin_country-disputed',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 1,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          'hsl(218, 20%, 22%)',
          13,
          'hsl(218, 5%, 22%)',
        ],
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [1, 3]],
          5,
          ['literal', [1.5, 2.5]],
          8,
          ['literal', [2.5, 3]],
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.3],
          ['zoom'],
          1,
          0.5,
          6,
          3,
          15,
          5,
        ],
      },
      source: 'aws',
      'source-layer': 'boundaries',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'ferry'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'ferry_line',
      layout: {
        'line-join': 'round',
      },
      minzoom: 9,
      paint: {
        'line-color': 'hsl(194, 30%, 40%)',
        'line-dasharray': [3.5, 4.5],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.75,
          12,
          1,
          14,
          1.5,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'ferry'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'ferrylabel',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-letter-spacing': 0.05,
        'text-max-angle': 40,
        'text-offset': [0, 0.05],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          9,
          18,
          17,
          22,
          25,
        ],
      },
      minzoom: 10,
      paint: {
        'text-color': 'hsl(194, 58%, 46%)',
        'text-halo-blur': 0.75,
        'text-halo-color': 'hsla(194, 48%, 8%, 0.7)',
        'text-halo-width': 1,
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['==', ['get', 'kind_detail'], 'pier'],
          true,
          ['==', ['get', 'kind_detail'], 'quay'],
          true,
          ['==', ['get', 'landuse_kind'], 'pier'],
          true,
          ['==', ['get', 'landuse_kind'], 'quay'],
          true,
          false,
        ],
        ['!=', ['get', 'kind'], 'rail'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'water_pier-line',
      minzoom: 15,
      paint: {
        'line-color': 'hsl(0, 0%, 80%)',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          2,
          17,
          7,
          20,
          50,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind'], ['bridge', 'pier', 'quay'], true, false],
        ['==', ['geometry-type'], 'Polygon'],
      ],
      id: 'water_pier-polygon',
      minzoom: 12,
      paint: {
        'fill-color': 'hsl(0, 0%, 80%)',
      },
      source: 'aws',
      'source-layer': 'landuse',
      type: 'fill',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_tertiary-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-color': 'hsla(200, 5%, 71%, 0.9)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [6, 4]],
          18,
          ['literal', [10, 5]],
          20,
          ['literal', [12, 8]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.6,
          12,
          1,
          14,
          2,
          17,
          10,
          18,
          10,
          20,
          70,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_primary-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [8, 4]],
          16,
          ['literal', [10, 5]],
          18,
          ['literal', [12, 8]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_motorway-trunk-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 13.5,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [5, 3]],
          16,
          ['literal', [8, 4]],
          17,
          ['literal', [12, 5]],
          18,
          ['literal', [15, 8]],
          19,
          ['literal', [20, 10]],
          20,
          ['literal', [30, 15]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
        'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_tertiary-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-color': 'hsla(200, 5%, 71%, 0.9)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [6, 4]],
          18,
          ['literal', [10, 5]],
          20,
          ['literal', [12, 8]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0.6,
          12,
          1,
          14,
          3,
          17,
          12,
          18,
          22,
          20,
          100,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 18, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_primary-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [8, 4]],
          16,
          ['literal', [10, 5]],
          18,
          ['literal', [12, 8]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 14, 0.6, 18, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_bridge']],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_motorway-trunk-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-dasharray': [
          'step',
          ['zoom'],
          ['literal', [10, 0]],
          15,
          ['literal', [5, 3]],
          16,
          ['literal', [8, 4]],
          17,
          ['literal', [12, 5]],
          18,
          ['literal', [15, 8]],
          19,
          ['literal', [20, 10]],
          20,
          ['literal', [30, 15]],
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          0.7,
          9,
          0.8,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 12, 0.6, 15, 2],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'path'],
        ['!', ['has', 'footway']],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['!=', ['get', 'landuse_kind'], 'pier'],
        ['!=', ['get', 'kind_detail'], 'pier'],
        true,
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_path',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 15,
      paint: {
        'line-color': 'hsl(0, 0%, 84%)',
        'line-dasharray': [0.03, 1.75],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          1,
          14,
          1.25,
          15,
          1.5,
          16,
          1.75,
          17,
          2.5,
          18,
          3.5,
          19,
          5,
          20,
          8,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          ['minor_road', 'unclassified', 'track'],
          true,
          false,
        ],
        ['!=', ['get', 'kind_detail'], 'service'],
        ['!=', ['get', 'private'], true],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_minor-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 14.5,
      paint: {
        'line-color': 'hsla(200, 5%, 71%, 0.9)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.5,
          1,
          15,
          3,
          17,
          8,
          18,
          15,
          20,
          80,
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 14.5, 1, 15, 0],
        'line-width': ['interpolate', ['linear'], ['zoom'], 14.5, 0.8, 18, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_tertiary-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12.5,
      paint: {
        'line-color': 'hsla(200, 5%, 71%, 0.9)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.6,
          12,
          1,
          14,
          2,
          17,
          10,
          18,
          10,
          20,
          70,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          0,
          13,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.6, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_primary-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          'hsl(0, 0%, 100%)',
          12.75,
          'hsla(200, 5%, 71%, 0.9)',
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_motorway-trunk-link-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 13.5,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
        'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_link']],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_tertiary-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12.5,
      paint: {
        'line-color': 'hsla(200, 5%, 71%, 0.9)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0.6,
          12,
          1,
          14,
          3,
          17,
          12,
          18,
          22,
          20,
          100,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          0,
          13,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 14, 1.125, 15, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_link']],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_primary-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          'hsl(0, 0%, 100%)',
          12.75,
          'hsla(200, 5%, 71%, 0.9)',
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 13, 1, 15, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_link']],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_motorway-trunk-casing',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          0.7,
          9,
          0.8,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.5,
          13,
          0.6,
          15,
          1.5,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        [
          'match',
          ['get', 'kind'],
          ['minor_road', 'unclassified', 'track'],
          true,
          false,
        ],
        ['!=', ['get', 'kind_detail'], 'service'],
        ['!=', ['get', 'private'], true],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_minor',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': 'hsl(218, 10%, 92%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          0,
          13,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.5,
          1,
          15,
          3,
          17,
          8,
          18,
          15,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_tertiary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': 'hsl(218, 10%, 92%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11.5,
          0,
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.6,
          12,
          1,
          14,
          2,
          17,
          10,
          18,
          10,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_primary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(218, 20%, 83%)',
          15,
          'hsl(218, 20%, 83%)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0,
          11.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['has', 'is_link'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_motorway-trunk-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.25,
          'hsl(218, 20%, 85%)',
          13.5,
          'hsl(218, 20%, 85%)',
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_tertiary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': 'hsl(218, 10%, 92%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          0,
          12.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0.6,
          12,
          1,
          14,
          3,
          17,
          12,
          18,
          22,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_bridge']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_primary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 9,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(218, 20%, 83%)',
          15,
          'hsl(218, 20%, 83%)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0,
          9.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['has', 'is_tunnel'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_bridge']],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'tunnel_motorway-trunk',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': 'hsl(218, 20%, 85%)',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          0.7,
          9,
          0.8,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          ['minor_road', 'unclassified', 'track'],
          true,
          false,
        ],
        ['!=', ['get', 'kind_detail'], 'service'],
        ['!=', ['get', 'private'], true],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_minor',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16,
          'hsla(218, 5%, 90%, 0.9)',
          17,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          0,
          13,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.5,
          1,
          15,
          3,
          17,
          8,
          18,
          15,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_tertiary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 5%, 90%, 0.9)',
          16,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11.5,
          0,
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.6,
          12,
          1,
          14,
          2,
          17,
          10,
          18,
          10,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_primary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          'hsl(0, 0%, 100%)',
          13,
          'hsla(218, 10%, 90%, 0.8)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['has', 'is_link'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_motorway-trunk-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.25,
          'hsl(218, 20%, 85%)',
          13.5,
          'hsla(218, 84%, 98%, 0.9)',
          15,
          'hsla(218, 84%, 98%, 0.9)',
          16,
          'hsla(218, 84%, 90%, 0.9)',
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_link']],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_tertiary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 10,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 5%, 90%, 0.9)',
          16,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0,
          10.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0.6,
          12,
          1,
          14,
          3,
          17,
          12,
          18,
          22,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind_detail'], 'secondary'],
        [
          'any',
          ['!', ['has', 'is_bridge']],
          ['!', ['has', 'z_level']],
          ['==', ['get', 'z_level'], 0],
        ],
        ['!', ['has', 'is_tunnel']],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_primary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          'hsl(218, 10%, 90%)',
          14.5,
          'hsla(218, 10%, 90%, 0.9)',
          15,
          'hsla(218, 10%, 90%, 0.8)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          [
            'any',
            [
              'any',
              ['!', ['has', 'is_bridge']],
              ['!', ['has', 'z_level']],
              ['==', ['get', 'z_level'], 0],
            ],
            ['!', ['has', 'is_tunnel']],
            ['has', 'is_bridge'],
            ['has', 'is_tunnel'],
          ],
          12,
          ['all', ['!', ['has', 'is_bridge']], ['!', ['has', 'is_tunnel']]],
        ],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'road_motorway-trunk',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 5,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 84%, 98%, 0.9)',
          16,
          'hsla(218, 84%, 90%, 0.9)',
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          5,
          1,
          7,
          1.5,
          9,
          2,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
        ['step', ['zoom'], ['!', ['has', 'service']], 14, true],
        ['!', ['has', 'is_bridge']],
        ['!', ['has', 'is_tunnel']],
        [
          'case',
          [
            'all',
            ['has', 'kind_detail'],
            ['==', ['get', 'kind_detail'], 'disused'],
          ],
          false,
          true,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'rail_road',
      layout: {
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16,
          'hsl(180, 8%, 65%)',
          17,
          'hsl(0, 0%, 75%)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11.5,
          0,
          12,
          ['case', ['has', 'service'], 0, 1],
          14.5,
          ['case', ['has', 'service'], 0, 1],
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          1,
          17,
          1.5,
          20,
          2,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['has', 'is_link'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk-link-shadow',
      layout: {
        'line-join': 'round',
      },
      minzoom: 15,
      paint: {
        'line-blur': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          8,
          17,
          12,
          18,
          12,
          20,
          30,
        ],
        'line-color': 'hsl(0, 0%, 0%)',
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 0.3],
        'line-translate': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          ['literal', [1, 1]],
          17,
          ['literal', [3, 3]],
          18,
          ['literal', [4.5, 4.5]],
          20,
          ['literal', [9, 9]],
        ],
        'line-translate-anchor': 'viewport',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          4,
          17,
          14,
          18,
          17,
          20,
          88,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_link']],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_tertiary-shadow',
      layout: {
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-blur': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          5,
          17,
          15,
          18,
          25,
          20,
          45,
        ],
        'line-color': 'hsl(0, 0%, 0%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          0.3,
          15,
          0,
        ],
        'line-translate': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          ['literal', [1.5, 1.5]],
          17,
          ['literal', [4, 4]],
          18,
          ['literal', [5, 5]],
          20,
          ['literal', [9, 9]],
        ],
        'line-translate-anchor': 'viewport',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          4,
          17,
          14,
          18,
          26,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_link']],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_primary-secondary-shadow',
      layout: {
        'line-join': 'round',
      },
      minzoom: 14,
      paint: {
        'line-blur': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          8,
          17,
          15,
          18,
          15,
          20,
          30,
        ],
        'line-color': 'hsl(0, 0%, 0%)',
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          0,
          14.5,
          0.3,
          15,
          0,
        ],
        'line-translate': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          ['literal', [3, 3]],
          17,
          ['literal', [5, 5]],
          18,
          ['literal', [6, 6]],
          20,
          ['literal', [10, 10]],
        ],
        'line-translate-anchor': 'viewport',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          5,
          17,
          18,
          18,
          35,
          20,
          110,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_link']],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk-shadow',
      layout: {
        'line-join': 'round',
      },
      minzoom: 13,
      paint: {
        'line-blur': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          8,
          17,
          15,
          18,
          15,
          20,
          30,
        ],
        'line-color': 'hsl(0, 0%, 0%)',
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 13, 0, 13.5, 0.3],
        'line-translate': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          ['literal', [3, 3]],
          17,
          ['literal', [5, 5]],
          18,
          ['literal', [6, 6]],
          20,
          ['literal', [10, 10]],
        ],
        'line-translate-anchor': 'viewport',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14,
          5,
          17,
          25,
          18,
          54,
          20,
          210,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_primary-link-casing',
      layout: {
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(0, 0%, 100%)',
          14.75,
          'hsla(200, 5%, 71%, 0.9)',
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          0,
          12.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['has', 'is_link'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk-link-casing',
      layout: {
        'line-join': 'round',
      },
      minzoom: 13.5,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 14, 1],
        'line-width': ['interpolate', ['linear'], ['zoom'], 13, 0.4, 17, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_link']],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_primary-casing',
      layout: {
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          14.5,
          'hsl(0, 0%, 100%)',
          14.75,
          'hsla(200, 5%, 71%, 0.9)',
        ],
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          0,
          12.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 13, 1, 15, 1.5],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_link']],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk-casing',
      layout: {
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': 'hsl(218, 30%, 91%)',
        'line-gap-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          0.7,
          9,
          0.8,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.5,
          13,
          0.6,
          15,
          1.5,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'path'],
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['!', ['has', 'footway']],
        true,
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_path',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 15,
      paint: {
        'line-color': 'hsl(0, 0%, 84%)',
        'line-dasharray': [0.03, 1.75],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          1,
          14,
          1.25,
          15,
          1.5,
          16,
          1.75,
          17,
          2.5,
          18,
          3.5,
          19,
          5,
          20,
          8,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        [
          'match',
          ['get', 'kind'],
          ['minor_road', 'unclassified', 'track'],
          true,
          false,
        ],
        ['!=', ['get', 'kind_detail'], 'service'],
        ['!=', ['get', 'private'], true],
        ['!', ['has', 'is_tunnel']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_minor',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16,
          'hsla(218, 5%, 90%, 0.9)',
          17,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12.5,
          0,
          13,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.5,
          1,
          15,
          3,
          17,
          8,
          18,
          15,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['has', 'is_link'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_tertiary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 5%, 90%, 0.9)',
          16,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11.5,
          0,
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0.6,
          12,
          1,
          14,
          2,
          17,
          10,
          18,
          10,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['has', 'is_link'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_primary-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          'hsl(218, 10%, 90%)',
          14.5,
          'hsla(218, 10%, 90%, 0.9)',
          15,
          'hsla(218, 10%, 90%, 0.8)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          0,
          11.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11,
          1,
          14,
          2.5,
          17,
          10,
          18,
          14,
          20,
          80,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['has', 'is_link'],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk-link',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13.25,
          'hsl(218, 20%, 85%)',
          13.5,
          'hsla(218, 84%, 98%, 0.9)',
          15,
          'hsla(218, 84%, 98%, 0.9)',
          16,
          'hsla(218, 84%, 90%, 0.9)',
        ],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.5, 1],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8,
          0.7,
          10,
          1,
          11,
          1.25,
          13,
          2,
          14,
          2.5,
          17,
          12,
          18,
          14,
          20,
          70,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'tertiary'],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_tertiary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 10,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 5%, 90%, 0.9)',
          16,
          'hsla(218, 84%, 98%, 0.9)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0,
          10.5,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0.6,
          12,
          1,
          14,
          3,
          17,
          12,
          18,
          22,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        ['==', ['get', 'kind_detail'], 'secondary'],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_primary',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 8,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          'hsl(218, 10%, 90%)',
          14.5,
          'hsla(218, 10%, 90%, 0.9)',
          15,
          'hsla(218, 10%, 90%, 0.8)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8.5,
          0,
          9,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          0.8,
          11,
          1.25,
          12,
          2,
          14,
          4,
          17,
          16,
          18,
          30,
          20,
          100,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['any', ['has', 'is_bridge'], ['>', ['get', 'z_level'], 0]],
        [
          'match',
          ['get', 'kind_detail'],
          ['motorway', 'trunk', 'primary'],
          true,
          false,
        ],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'bridge_motorway-trunk',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          'hsla(218, 84%, 98%, 0.9)',
          16,
          'hsla(218, 84%, 90%, 0.9)',
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          0.7,
          9,
          0.8,
          11,
          2,
          12,
          3,
          14,
          5,
          17,
          20,
          18,
          50,
          20,
          200,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind'], ['transit', 'rail'], true, false],
        ['has', 'is_bridge'],
        ['!', ['has', 'service']],
        [
          'case',
          [
            'all',
            ['has', 'kind_detail'],
            ['==', ['get', 'kind_detail'], 'disused'],
          ],
          false,
          true,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'rail_bridge',
      layout: {
        'line-join': 'round',
      },
      minzoom: 11,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16,
          'hsl(180, 8%, 65%)',
          17,
          'hsl(0, 0%, 75%)',
        ],
        'line-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          11.5,
          0,
          12,
          1,
          14.5,
          1,
          15,
          0,
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          1,
          17,
          1.5,
          20,
          2,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'line',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          ['<', ['to-number', ['get', 'display_class']], 5],
          9,
          ['<', ['to-number', ['get', 'display_class']], 7],
          10,
          ['<', ['to-number', ['get', 'display_class']], 8],
          13,
          true,
        ],
        [
          'match',
          ['get', 'kind'],
          ['reef', 'riverbank', 'fountain', 'playa', 'river'],
          false,
          true,
        ],
        ['!=', ['get', 'name'], 'Pool'],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'waterlabel_point',
      layout: {
        'symbol-sort-key': ['to-number', ['get', 'display_class']],
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
        'text-letter-spacing': 0.1,
        'text-line-height': 1,
        'text-max-width': 5,
        'text-padding': 40,
        'text-size': ['interpolate', ['linear'], ['zoom'], 12, 10, 16, 12],
      },
      minzoom: 0,
      paint: {
        'text-color': 'hsl(194, 58%, 46%)',
        'text-halo-blur': 0.8,
        'text-halo-color': 'hsla(194, 48%, 8%, 0.7)',
        'text-halo-width': 1.2,
      },
      source: 'aws',
      'source-layer': 'water',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['!', ['has', 'is_tunnel']],
        ['!', ['has', 'intermittent']],
        [
          'match',
          ['get', 'kind'],
          ['reef', 'riverbank', 'fountain', 'playa'],
          false,
          true,
        ],
        ['case', ['has', 'name:en'], true, ['has', 'name'], true, false],
        [
          'case',
          [
            '<=',
            ['length', ['coalesce', ['get', 'name:en'], ['get', 'name']]],
            20,
          ],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'waterlabel_line',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 500,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
        'text-letter-spacing': 0.3,
        'text-size': ['interpolate', ['linear'], ['zoom'], 12, 10, 16, 12],
      },
      minzoom: 12,
      paint: {
        'text-color': 'hsl(194, 58%, 46%)',
        'text-halo-blur': 0.8,
        'text-halo-color': 'hsla(194, 48%, 8%, 0.7)',
        'text-halo-width': 1.5,
      },
      source: 'aws',
      'source-layer': 'water',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'address'],
        ['has', 'addr_housenumber'],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'bldglabel_number',
      layout: {
        'text-field': ['to-string', ['get', 'addr_housenumber']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-letter-spacing': [
          'interpolate',
          ['linear'],
          ['zoom'],
          17,
          0.07,
          18,
          0.03,
        ],
        'text-padding': 1,
        'text-size': ['interpolate', ['linear'], ['zoom'], 17, 10, 22, 14],
      },
      minzoom: 17,
      paint: {
        'text-color': 'hsl(0, 0%, 97%)',
        'text-halo-color': 'hsl(0, 0%, 13%)',
        'text-halo-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          17,
          0.8,
          18,
          1,
        ],
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 17.5, 0, 18, 1],
      },
      source: 'aws',
      'source-layer': 'buildings',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'minor_road'],
        [
          'any',
          ['==', ['get', 'kind_detail'], 'service'],
          [
            'all',
            ['==', ['get', 'kind_detail'], 'residential'],
            ['==', ['get', 'private'], true],
          ],
        ],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'roadlabel_service',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
        'text-max-angle': 40,
        'text-offset': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          ['literal', [0, -0.3]],
          14,
          ['literal', [0, 0.02]],
        ],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          8,
          18,
          14,
          22,
          20,
        ],
      },
      minzoom: 14,
      paint: {
        'text-color': 'hsl(0, 1%, 100%)',
        'text-halo-blur': 0.75,
        'text-halo-color': 'hsl(0, 0%, 21%)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'minor_road'],
        ['!=', ['get', 'kind_detail'], 'service'],
        ['!=', ['get', 'private'], true],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'roadlabel_small',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 200,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-angle': 40,
        'text-offset': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          ['literal', [0, -0.3]],
          14,
          ['literal', [0, 0.02]],
        ],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          8,
          18,
          16,
          22,
          24,
        ],
        'text-transform': 'uppercase',
      },
      minzoom: 13,
      paint: {
        'text-color': 'hsl(0, 1%, 100%)',
        'text-halo-color': 'hsl(0, 0%, 21%)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'match',
            ['get', 'kind_detail'],
            ['primary', 'secondary'],
            true,
            false,
          ],
          10.25,
          [
            'match',
            ['get', 'kind_detail'],
            ['primary', 'secondary', 'tertiary'],
            true,
            false,
          ],
        ],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'roadlabel_medium',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 300,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-angle': 40,
        'text-offset': [0, 0.05],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          9,
          18,
          17,
          22,
          25,
        ],
        'text-transform': 'uppercase',
      },
      minzoom: 9,
      paint: {
        'text-color': 'hsl(0, 1%, 100%)',
        'text-halo-color': 'hsl(0, 0%, 21%)',
        'text-halo-width': 1,
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['in', '700-7', ['get', 'pds_category']],
        ['has', 'pds_category'],
      ],
      id: 'poi_700_business_services_generic',
      layout: {
        'icon-image': [
          'case',
          ['in', '700-70', ['get', 'pds_category']],
          'money',
          ['in', '700-7460', ['get', 'pds_category']],
          'information',
          ['in', '700-7600', ['get', 'pds_category']],
          'gas-station',
          ['in', '700-78', ['get', 'pds_category']],
          'car',
          ['in', '700-7300', ['get', 'pds_category']],
          'police',
          'marker',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 17.9,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['in', '800-8', ['get', 'pds_category']],
        ['has', 'pds_category'],
      ],
      id: 'poi_800_facilities_generic',
      layout: {
        'icon-image': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['800-8000-0159', '800-8000-0325']],
          ],
          'hospital',
          ['in', '800-8000', ['get', 'pds_category']],
          'doctor',
          ['in', '800-8100', ['get', 'pds_category']],
          'government',
          ['in', '700-7600', ['get', 'pds_category']],
          'gas-station',
          ['in', '800-82', ['get', 'pds_category']],
          'education',
          ['in', '800-83', ['get', 'pds_category']],
          'book',
          ['in', '800-85', ['get', 'pds_category']],
          'parking',
          ['in', '800-8600-0180', ['get', 'pds_category']],
          'stadium',
          ['in', '800-8600-0182', ['get', 'pds_category']],
          'swimming',
          ['in', '800-8600-0191', ['get', 'pds_category']],
          'gym',
          ['in', '800-8700-0166', ['get', 'pds_category']],
          'cemetery',
          ['in', '800-86', ['get', 'pds_category']],
          'outdoor',
          'marker',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 17.9,
      paint: {
        'text-color': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['800-8000-0159', '800-8000-0325']],
          ],
          'hsl(51, 40%, 92%)',
          'hsl(192, 8%, 95%)',
        ],
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['in', '100-1', ['get', 'pds_category']],
        ['has', 'pds_category'],
      ],
      id: 'poi_100_food_drink',
      layout: {
        'icon-image': [
          'case',
          ['in', '100-1000-0009', ['get', 'pds_category']],
          'fast-food',
          ['in', '100-1000', ['get', 'pds_category']],
          'restaurant',
          ['in', '100-1100', ['get', 'pds_category']],
          'coffee',
          'marker_food_drink',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 17.9,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          ['in', '500-5000', ['get', 'pds_category']],
          17,
          ['in', '500-5', ['get', 'pds_category']],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_500_accommodations',
      layout: {
        'icon-image': 'accommodation',
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 16.5,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'all',
            ['has', 'has_national_importance'],
            ['in', '600-6100', ['get', 'pds_category']],
          ],
          15,
          ['in', '600-6100', ['get', 'pds_category']],
          16,
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['600-6100', '600-6200', '600-6400']],
          ],
          17,
          ['in', '600-6', ['get', 'pds_category']],
        ],
        ['in', '600-6', ['get', 'pds_category']],
        ['has', 'pds_category'],
      ],
      id: 'poi_600_shopping',
      layout: {
        'icon-image': [
          'case',
          ['in', '600-6100', ['get', 'pds_category']],
          'shopping',
          ['in', '600-6400', ['get', 'pds_category']],
          'pharmacy',
          ['in', '600-6700', ['get', 'pds_category']],
          'book',
          ['in', '600-6300', ['get', 'pds_category']],
          'grocery',
          ['in', '600-6950', ['get', 'pds_category']],
          'salon',
          'shopping',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 14,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['in', '550-5', ['get', 'pds_category']],
        ['!', ['in', '550-5510-0202', ['get', 'pds_category']]],
        ['has', 'pds_category'],
      ],
      id: 'poi_550_leisure_outdoor',
      layout: {
        'icon-image': [
          'case',
          ['in', '550-5510', ['get', 'pds_category']],
          'outdoor',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['550-5520-0212', '550-5510-0227']],
          ],
          'ski',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['550-5510-0205', '550-5520-0357']],
          ],
          'swimming',
          ['in', '550-5510-0378', ['get', 'pds_category']],
          'camping',
          'nature',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 14,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'all',
            ['has', 'has_national_importance'],
            ['in', '800-8600-0180', ['get', 'pds_category']],
          ],
          15,
          ['in', '800-8600-0180', ['get', 'pds_category']],
          16,
          [
            'any',
            ['in', '800-8100-0163', ['get', 'pds_category']],
            ['in', '800-8100-0168', ['get', 'pds_category']],
            ['in', '800-8100-0170', ['get', 'pds_category']],
            ['in', '800-8300-0175', ['get', 'pds_category']],
            ['in', '800-8600-0180', ['get', 'pds_category']],
          ],
          17,
          [
            'any',
            ['in', '800-8100', ['get', 'pds_category']],
            ['in', '800-8300-0175', ['get', 'pds_category']],
            ['in', '800-8600-0180', ['get', 'pds_category']],
            ['in', '800-8600-0191', ['get', 'pds_category']],
          ],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_800_facilities',
      layout: {
        'icon-image': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['800-8000-0159', '800-8000-0325']],
          ],
          'hospital',
          ['in', '800-8000', ['get', 'pds_category']],
          'doctor',
          ['in', '800-8100', ['get', 'pds_category']],
          'government',
          ['in', '700-7600', ['get', 'pds_category']],
          'gas-station',
          ['in', '800-82', ['get', 'pds_category']],
          'education',
          ['in', '800-83', ['get', 'pds_category']],
          'book',
          ['in', '800-85', ['get', 'pds_category']],
          'parking',
          ['in', '800-8600-0180', ['get', 'pds_category']],
          'stadium',
          ['in', '800-8600-0182', ['get', 'pds_category']],
          'swimming',
          ['in', '800-8600-0191', ['get', 'pds_category']],
          'gym',
          ['in', '800-8700-0166', ['get', 'pds_category']],
          'cemetery',
          ['in', '800-86', ['get', 'pds_category']],
          'outdoor',
          'marker',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 13,
      paint: {
        'text-color': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['800-8000-0159', '800-8000-0325']],
          ],
          'hsl(51, 40%, 92%)',
          'hsl(192, 8%, 95%)',
        ],
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'all',
            ['has', 'has_national_importance'],
            ['in', '300-3', ['get', 'pds_category']],
          ],
          16,
          [
            'any',
            [
              'all',
              ['in', '300-3', ['get', 'pds_category']],
              ['has', 'has_national_importance'],
            ],
            ['in', '300-3200', ['get', 'pds_category']],
          ],
          17,
          ['in', '300-3', ['get', 'pds_category']],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_300_sights_museums',
      layout: {
        'icon-image': [
          'case',
          ['in', '550-5510', ['get', 'pds_category']],
          'outdoor',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['550-5520-0212', '550-5510-0227']],
          ],
          'ski',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['550-5510-0205', '550-5520-0357']],
          ],
          'swimming',
          ['in', '550-5510-0378', ['get', 'pds_category']],
          'camping',
          ['in', '300-3000', ['get', 'pds_category']],
          'attraction',
          ['in', '300-3100', ['get', 'pds_category']],
          'museum',
          ['in', '300-3200', ['get', 'pds_category']],
          'place-of-worship',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['350-3500-0235', '50-3550-0336', '350-3522-0239']],
          ],
          'nature',
          'marker_arts_entertainment',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 14,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'all',
            ['has', 'has_national_importance'],
            [
              'any',
              ['in', '200-2100', ['get', 'pds_category']],
              ['in', '200-2200', ['get', 'pds_category']],
            ],
          ],
          16,
          [
            'any',
            ['in', '200-2100', ['get', 'pds_category']],
            ['in', '200-2200', ['get', 'pds_category']],
          ],
          17,
          ['in', '200-2', ['get', 'pds_category']],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_200_going_out_entertainment',
      layout: {
        'icon-image': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['200-2000-0011', '200-2000-0011', '200-2000-0019']],
          ],
          'pub',
          ['in', '200-2000-0368', ['get', 'pds_category']],
          'cocktail',
          ['in', '200-2000', ['get', 'pds_category']],
          'nightclub',
          ['in', '200-2100', ['get', 'pds_category']],
          'cinema',
          ['in', '200-2200', ['get', 'pds_category']],
          'theater',
          ['in', '200-2300', ['get', 'pds_category']],
          'game',
          'marker_arts_entertainment',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 15,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'any',
          ['in', '700-7300', ['get', 'pds_category']],
          ['in', '700-7600', ['get', 'pds_category']],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_700_business_services',
      layout: {
        'icon-image': [
          'case',
          ['in', '700-70', ['get', 'pds_category']],
          'money',
          ['in', '700-7460', ['get', 'pds_category']],
          'information',
          ['in', '700-7600', ['get', 'pds_category']],
          'gas-station',
          ['in', '700-78', ['get', 'pds_category']],
          'car',
          ['in', '700-7300', ['get', 'pds_category']],
          'police',
          'marker',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 16,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['in', '900-9', ['get', 'pds_category']],
        ['has', 'pds_category'],
      ],
      id: 'poi_900_areas_buildings',
      layout: {
        'icon-image': [
          'case',
          ['in', '900-9300', ['get', 'pds_category']],
          'facilities',
          'marker',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
      },
      minzoom: 17.9,
      paint: {
        'text-color': 'hsl(192, 8%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          ['in', '400-4100-0035', ['get', 'pds_category']],
          15,
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0035', '400-4100-0037']],
          ],
          16,
          [
            'all',
            ['in', '400-4', ['get', 'pds_category']],
            [
              '!',
              [
                'in',
                ['get', 'pds_category'],
                [
                  'literal',
                  [
                    '400-4100-0036',
                    '400-4100-0042',
                    '400-4100-0341',
                    '400-4100-0040',
                    '400-4100-0041',
                    '400-4200-0240',
                  ],
                ],
              ],
            ],
          ],
          17,
          ['in', '400-4', ['get', 'pds_category']],
        ],
        [
          'match',
          ['get', 'pds_category'],
          ['400-4100-0225', '400-4100-0226'],
          false,
          true,
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_400_transit',
      layout: {
        'icon-image': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            [
              'literal',
              [
                '400-4100-0035',
                '400-4100-0046',
                '400-4100-0038',
                '400-4100-0039',
              ],
            ],
          ],
          'train',
          ['in', '400-4100-0037', ['get', 'pds_category']],
          'metro',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0044', '400-4100-0045', '400-4100-0338']],
          ],
          'ferry',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0036', '400-4100-0042', '400-4100-0341']],
          ],
          'bus',
          ['in', '400-4100-0337', ['get', 'pds_category']],
          'light-rail',
          ['in', '400-4100-0339', ['get', 'pds_category']],
          'monorail',
          ['in', '400-4100-0340', ['get', 'pds_category']],
          'cable-car',
          ['in', '400-4100-0342', ['get', 'pds_category']],
          'funicular',
          ['in', '400-4100-0047', ['get', 'pds_category']],
          'taxi',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0347', '400-4100-0348']],
          ],
          'bicycle',
          ['in', '400-4100-0040', ['get', 'pds_category']],
          'entrance',
          'marker_transit',
        ],
        'symbol-sort-key': ['get', 'pds_category'],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      minzoom: 13,
      paint: {
        'text-color': 'hsl(205, 22%, 95%)',
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'in',
          ['get', 'pds_category'],
          ['literal', ['400-4100-0036', '400-4100-0042', '400-4100-0341']],
        ],
        ['has', 'pds_category'],
      ],
      id: 'poi_400_transit_small',
      layout: {
        'icon-image': [
          'case',
          [
            'in',
            ['get', 'pds_category'],
            [
              'literal',
              [
                '400-4100-0035',
                '400-4100-0046',
                '400-4100-0038',
                '400-4100-0039',
              ],
            ],
          ],
          'train',
          ['in', '400-4100-0037', ['get', 'pds_category']],
          'metro',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0044', '400-4100-0045', '400-4100-0338']],
          ],
          'ferry',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0036', '400-4100-0042', '400-4100-0341']],
          ],
          'bus',
          ['in', '400-4100-0337', ['get', 'pds_category']],
          'light-rail',
          ['in', '400-4100-0339', ['get', 'pds_category']],
          'monorail',
          ['in', '400-4100-0340', ['get', 'pds_category']],
          'cable-car',
          ['in', '400-4100-0342', ['get', 'pds_category']],
          'funicular',
          ['in', '400-4100-0047', ['get', 'pds_category']],
          'taxi',
          [
            'in',
            ['get', 'pds_category'],
            ['literal', ['400-4100-0347', '400-4100-0348']],
          ],
          'bicycle',
          ['in', '400-4100-0040', ['get', 'pds_category']],
          'entrance',
          'marker_transit',
        ],
        'icon-size': 0.6,
        'symbol-sort-key': ['get', 'pds_category'],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 12],
      },
      maxzoom: 17,
      minzoom: 16,
      paint: {
        'text-halo-blur': 1.5,
        'text-halo-color': 'hsla(60, 33%, 9%, 0.7)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'reservation'],
        ['>=', ['zoom'], ['to-number', ['get', 'minzoom']]],
      ],
      id: 'label_reservation',
      layout: {
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-max-width': 5,
        'text-padding': 50,
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
      },
      minzoom: 8,
      paint: {
        'text-color': 'hsl(26, 46%, 95%)',
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'landuse',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          ['park', 'cemetery', 'garden', 'zoo', 'golf_course'],
          true,
          false,
        ],
        ['>=', ['zoom'], ['to-number', ['get', 'min_zoom']]],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'poi_landuse_park_lowzoom',
      layout: {
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-max-width': 4,
        'text-padding': 40,
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
      },
      maxzoom: 16,
      minzoom: 14,
      paint: {
        'text-color': [
          'case',
          [
            'match',
            ['get', 'kind'],
            ['sports_centre', 'cemetery'],
            true,
            false,
          ],
          'hsl(192, 8%, 95%)',
          'hsl(111, 40%, 92%)',
        ],
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'landuse',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          ['park', 'cemetery', 'garden', 'zoo', 'golf_course'],
          true,
          false,
        ],
        ['>=', ['zoom'], ['to-number', ['get', 'min_zoom']]],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'poi_landuse_park',
      layout: {
        'icon-image': [
          'case',
          ['==', ['get', 'kind'], 'cemetery'],
          'cemetery',
          'park',
        ],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
      },
      minzoom: 16,
      paint: {
        'text-color': [
          'case',
          ['==', ['get', 'kind'], 'cemetery'],
          'hsl(192, 8%, 95%)',
          'hsl(111, 40%, 92%)',
        ],
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'landuse',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind'],
          [
            'hospital',
            'university',
            'commercial',
            'industrial',
            'harbour',
            'military',
          ],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'poi_landuse_public_complex',
      layout: {
        'icon-image': [
          'match',
          ['get', 'kind'],
          'hospital',
          'hospital',
          'commercial',
          'shopping',
          'university',
          'education',
          'marker',
        ],
        'text-anchor': 'top',
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-offset': [0, 1.5],
        'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 16, 11],
      },
      minzoom: 14,
      paint: {
        'text-color': [
          'match',
          ['get', 'kind'],
          'hospital',
          'hsl(51, 40%, 92%)',
          'university',
          'hsl(51, 40%, 92%)',
          'hsl(192, 8%, 95%)',
        ],
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'landuse',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'airport'],
        ['has', 'name:short'],
        [
          'step',
          ['zoom'],
          [
            'case',
            ['==', ['get', 'kind_detail'], 'international'],
            true,
            ['==', ['get', 'kind_detail'], 'regional'],
            true,
            ['has', 'has_national_importance'],
            true,
            false,
          ],
          12,
          true,
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'airportlabel',
      layout: {
        'icon-anchor': 'top',
        'icon-image': 'airport',
        'icon-rotation-alignment': 'viewport',
        'symbol-sort-key': [
          'case',
          ['has', 'kind_detail'],
          0,
          ['has', 'has_national_importance'],
          0,
          1,
        ],
        'text-anchor': 'bottom',
        'text-field': [
          'step',
          ['zoom'],
          ['get', 'name:short'],
          13,
          [
            'concat',
            ['coalesce', ['get', 'name:en'], ['get', 'name']],
            ' (',
            ['get', 'name:short'],
            ')',
          ],
        ],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-max-width': 4,
        'text-offset': [0, 0],
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          12,
          14,
          12,
          16,
          16,
        ],
      },
      minzoom: 10,
      paint: {
        'text-color': 'hsl(60, 0%, 98%)',
        'text-halo-blur': 0.8,
        'text-halo-color': 'hsl(254, 10%, 12%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'pois',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
        ['!', ['has', 'is_link']],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'roadlabel_large',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 300,
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-angle': 40,
        'text-offset': [0, 0.05],
        'text-padding': 1,
        'text-pitch-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12,
          10,
          18,
          18,
          22,
          26,
        ],
        'text-transform': 'uppercase',
      },
      minzoom: 8,
      paint: {
        'text-color': 'hsl(0, 0%, 100%)',
        'text-halo-color': 'hsl(0, 0%, 21%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'network'],
          [
            '首都高速道路',
            'А',
            'ЭМ',
            'AE',
            'AE:E-route',
            'am:national',
            'Arab Mashreq International Road Network',
            'Arab_Mashreq_International_Road_Network',
            'AR:AR',
            'AR:national',
            'AsianHighway',
            'AH',
            'AT:A-road',
            'AT:S-road',
            'AU:NT:NR',
            'AU:QLD:NR',
            'AU:VIC:NR',
            'AU:WA:NR',
            'Autoceste',
            'Autoroute du Maroc',
            'Autostradat shtetërore',
            'BAB',
            'ba:Autoceste',
            'ba:Magistralne ceste',
            'BD:national',
            'BE:A-road',
            'BE:N-road',
            'Routes nationales du Bénin',
            'Routes nationales Inter-État du Bénin',
            'Routes_nationales_de_la_République_du_Bénin',
            'Routes nationales des la République du Bénin',
            'bg:motorway',
            'bg:national',
            'BR',
            'BR:BR',
            'Route Nationale de Burkina Faso',
            'by:national',
            'ch:national',
            'CN:expressway',
            'CN:national',
            'CM-roads',
            'co:national',
            'CR:CR',
            'cy:national',
            'CZ:national',
            'cz:national',
            'DE:BAB',
            'DE:national',
            'dk:national',
            'Državne ceste',
            'DZ:national',
            'EC:provincial',
            'ee:national',
            'Emirates routes',
            'fi:national',
            'fi:trunk',
            'FR:A-road',
            'FR:N-road',
            'GA-roads',
            'GH:inter-regional',
            'GH:national',
            'ge:national',
            'GR:motorway',
            'GR:national',
            'HU:national',
            'IQ:national',
            'ir:freeways',
            'ir:national',
            'JP:JP',
            'KR:expressway',
            'KR:national',
            'LA-roads',
            'ls:national',
            'lt:national',
            'lv:national',
            'lv:regional',
            'LU:A-road',
            'LU:N-road',
            'MA:RN',
            'MA:RP',
            'na',
            'na:national',
            'Route Régionale du Maroc',
            'Route Provinciale du Maroc',
            'md:national',
            'me:magistralni_putevi',
            'M',
            'MEX',
            'mk:national',
            'MX:MX',
            'MX',
            'MY:E',
            'my:federal',
            'MY:Federal',
            'NL:A',
            'NL:binnenstedelijke_ring',
            'NL:N',
            'no:Riksvei',
            'NP:national',
            'np:national',
            'P',
            'PE:PE',
            'pe:national',
            'PH:E',
            'PH:N',
            'PK:national',
            'PK:motorway',
            'pl:expressways',
            'pl:national',
            'PT:national',
            'PY:national',
            'Qatar motorways',
            'RO:DN',
            'RS:national',
            'ru:national',
            'SA:national',
            'sadc',
            'SE:LV',
            'SE:RV',
            'Route nationale du Sénégal',
            'Route National du Senegal',
            'Routes Nationales du Sénégal',
            'Route Nationale du Senegal',
            'Routes Nationales du Senegal',
            'Route Regionale du Senegal',
            'Routes Regionales du Senegal',
            'sk:national',
            'TN:regional',
            'Route régionale de Tunisie',
            'TR:motorway',
            'TR-roads',
            'Route Nationale du Togo',
            'TW:expressway',
            'TW:freeway',
            'TW:provincial',
            'ua:international',
            'ua:national',
            'US:I',
            'US:US',
            'UY',
            'VN:Expressway',
            'VN:expressway',
            'XKX:national',
            'e-road',
            'za:capetown',
            'za:national',
            'za:regional',
            'ZM-roads',
          ],
          false,
          true,
        ],
        [
          'case',
          ['in', 'IN:', ['get', 'network']],
          false,
          ['in', 'IT:', ['get', 'network']],
          false,
          ['in', 'JP:', ['get', 'network']],
          false,
          ['in', 'NL:', ['get', 'network']],
          false,
          ['in', 'AU:', ['get', 'network']],
          false,
          ['in', 'US:', ['get', 'network']],
          false,
          true,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['!', ['has', 'is_link']],
        ['has', 'shield_text'],
        ['!', ['in', ';', ['get', 'shield_text']]],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_generic',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 4],
          'shield-rectangle-white',
          ['>=', ['length', ['get', 'shield_text']], 9],
          'shield-rectangle-white-xlong',
          'shield-rectangle-white-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          ['match', ['length', ['get', 'shield_text']], 4, 7, 8],
          12,
          ['match', ['length', ['get', 'shield_text']], 4, 9, 10],
        ],
        'text-transform': 'uppercase',
      },
      minzoom: 9,
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'Routes nationales du Bénin',
            'Routes nationales Inter-État du Bénin',
            'Routes_nationales_de_la_République_du_Bénin',
            'Routes nationales des la République du Bénin',
            'fi:trunk',
            'NL:N',
            'NL:N-road',
            'DE:national',
            'DE:BS',
            'DK:DK',
            'dk:national',
            'GH:inter-regional',
            'GH:national',
            'RS:national',
            'MA:RP',
            'Route Régionale du Maroc',
            'Route Provinciale du Maroc',
            'VN:Expressway',
            'VN:expressway',
          ],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'RS:national'],
            ['!', ['in', 'A', ['get', 'ref']]],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'RS:national']],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['has', 'kind_detail'],
      ],
      id: 'shield_yellow',
      layout: {
        'icon-image': 'shield-rectangle-yellow',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
        'text-color': 'hsl(0, 0%, 0%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'А',
            'ba:Autoceste',
            'BD:national',
            'bg:national',
            'e-road',
            'GB:A-road-white',
            'IQ:national',
            'ir:national',
            'me:magistralni_putevi',
            'no:Riksvei',
            'NP:national',
            'np:national',
            'Route régionale de Tunisie',
            'Route Regionale du Senegal',
            'Routes Regionales du Senegal',
            'TN:regional',
            'za:capetown',
            'za:regional',
          ],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'me:magistralni_putevi'],
            ['in', 'A', ['get', 'ref']],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'me:magistralni_pnautevi']],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['has', 'kind_detail'],
      ],
      id: 'shield_green',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 4],
          'shield-rectangle-green',
          'shield-rectangle-green-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
        'text-color': [
          'case',
          [
            'match',
            ['get', 'network'],
            ['za:capetown', 'za:regional'],
            true,
            false,
          ],
          'hsl(41, 94%, 68%)',
          'hsl(0, 0%, 100%)',
        ],
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'ЭМ',
            'am:national',
            'AsianHighway',
            'AH',
            'AT:A-road',
            'AT:S-road',
            'ba:Magistralne ceste',
            'BE:N-road',
            'bg:motorway',
            'cz:national',
            'Državne ceste',
            'ES:A-road',
            'ES:autonoma',
            'ge:national',
            'GB:M-road',
            'GR:national',
            'GR:GR',
            'IE:M-road',
            'ir:freeways',
            'lv:regional',
            'LU:A-road',
            'M',
            'me:magistralni_putevi',
            'P',
            'PT:motorway',
            'PT:national',
            'ru:national',
            'SE:LV',
            'SE:RV',
            'TR-roads',
            'TR:highway',
            'ua:national',
          ],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'me:magistralni_putevi'],
            ['in', 'M', ['get', 'ref']],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'me:magistralni_putevi']],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'GR:national'],
            ['!=', ['get', 'class'], 'motorway'],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'GR:national']],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['has', 'kind_detail'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_blue',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 4],
          'shield-rectangle-blue',
          'shield-rectangle-blue-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'Autoroute du Maroc',
            'Route Nationale de Burkina Faso',
            'by:national',
            'CN:national',
            'CM-roads',
            'CZ:national',
            'DZ:national',
            'ee:national',
            'fi:national',
            'FR:A-road',
            'FR:N-road',
            'GA-roads',
            'LA-roads',
            'lt:national',
            'lv:national',
            'LU:N-road',
            'MA:RN',
            'NL:A',
            'NL:A-road',
            'pl:expressways',
            'pl:national',
            'Route nationale du Sénégal',
            'Route National du Senegal',
            'Routes Nationales du Sénégal',
            'Route Nationale du Senegal',
            'Routes Nationales du Senegal',
            'sk:national',
            'Route Nationale du Togo',
            'ua:international',
          ],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_red',
      layout: {
        'icon-image': 'shield-rectangle-red',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.4, 0, 7.5, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.4, 0, 7.5, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'Autoceste',
            'GR:motorway',
            'GR:national',
            'mk:national',
            'RS:national',
            'XKX:national',
          ],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'GR:national'],
            ['match', ['get', 'class'], ['motorway', 'trunk'], true, false],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'GR:national']],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['has', 'kind_detail'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_green-hexagon',
      layout: {
        'icon-image': 'shield-green-hexagon',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['AU:NT:NR', 'AU:QLD:NR', 'AU:VIC:NR', 'AU:WA:NR'],
          false,
          true,
        ],
        ['in', 'AU:', ['get', 'network']],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_au',
      layout: {
        'icon-image': [
          'concat',
          'shield-',
          [
            'case',
            [
              'match',
              ['get', 'network'],
              ['AU:NT:S', 'AU:QLD:S', 'AU:VIC:S', 'AU:WA:S'],
              true,
              false,
            ],
            'AU:S',
            [
              'match',
              ['get', 'network'],
              [
                'AU:ACT:T',
                'AU:NSW:T',
                'AU:QLD:T',
                'AU:SA:T',
                'AU:VIC:T',
                'AU:WA:T',
              ],
              true,
              false,
            ],
            'AU:T',
            ['==', ['get', 'network'], 'AU:QLD:MR'],
            'AU:MR',
            [
              'match',
              ['get', 'network'],
              [
                'AU:NT:NH',
                'AU:QLD:NH',
                'AU:SA:NH',
                'AU:TAS:NH',
                'AU:VIC:NH',
                'AU:WA:NH',
              ],
              true,
              false,
            ],
            'AU:NH',
            'rectangle-green',
          ],
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'icon-text-fit-padding': [0, 10, 0, 10],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
        'text-color': [
          'case',
          [
            'match',
            ['get', 'network'],
            [
              'AU:NT:S',
              'AU:QLD:S',
              'AU:VIC:S',
              'AU:WA:S',
              'AU:ACT:T',
              'AU:NSW:T',
              'AU:QLD:T',
              'AU:SA:T',
              'AU:VIC:T',
              'AU:WA:T',
            ],
            true,
            false,
          ],
          'hsl(0, 0%, 100%)',
          'hsl(41, 94%, 68%)',
        ],
        'text-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['match', ['get', 'network'], ['BE:A-road', 'BE:R-road'], true, false],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_be',
      layout: {
        'icon-image': 'shield-rectangle-white',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7,
          ['match', ['length', ['get', 'shield_text']], 4, 7, 8],
          12,
          ['match', ['length', ['get', 'shield_text']], 4, 9, 10],
        ],
        'text-transform': 'uppercase',
      },
      minzoom: 8,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.1, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.1, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['in', 'IN:', ['get', 'network']],
        ['<=', ['length', ['get', 'shield_text']], 7],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_in',
      layout: {
        'icon-image': [
          'case',
          [
            'any',
            [
              'all',
              ['in', 'IN:NH', ['get', 'network']],
              ['>=', ['length', ['get', 'shield_text']], 4],
            ],
            ['in', 'IN:NE', ['get', 'network']],
          ],
          'shield-IN-National-wide',
          [
            'all',
            ['in', 'IN:NH', ['get', 'network']],
            ['<=', ['length', ['get', 'shield_text']], 3],
          ],
          'shield-IN-National',
          ['in', 'IN:SH', ['get', 'network']],
          'shield-IN-State',
          [
            'all',
            ['!', ['in', 'IN:NH', ['get', 'network']]],
            ['<=', ['length', ['get', 'shield_text']], 3],
          ],
          'shield-rectangle-white',
          'shield-rectangle-white-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': [
          'case',
          ['in', 'IN:NE', ['get', 'network']],
          ['concat', 'NE', ['to-string', ['get', 'shield_text']]],
          ['to-string', ['get', 'shield_text']],
        ],
        'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
        'text-letter-spacing': -0.03,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 10,
      paint: {
        'text-color': [
          'case',
          ['in', 'IN:SH', ['get', 'network']],
          'hsl(0, 0%, 100%)',
          'hsl(0, 0%, 0%)',
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['in', 'IT:', ['get', 'network']],
        [
          'match',
          ['get', 'shield_text'],
          [
            'RA1',
            'RA10',
            'RA11',
            'RA12',
            'RA13',
            'RA14',
            'RA15',
            'RA16',
            'RA2',
            'RA3',
            'RA4',
            'RA5',
            'RA6',
            'RA8',
            'RA9',
          ],
          false,
          true,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_it-blue',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 4],
          'shield-rectangle-blue',
          'shield-rectangle-blue-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 8,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 8.4, 0, 8.5, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 8.4, 0, 8.5, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['Autostradat shtetërore', 'IT:A-road'],
          true,
          false,
        ],
        [
          'case',
          [
            'all',
            ['==', ['get', 'network'], 'Autostradat shtetërore'],
            ['in', 'A', ['get', 'shield_text']],
          ],
          true,
          ['any', ['!=', ['get', 'network'], 'Autostradat shtetërore']],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        ['==', ['get', 'kind_detail'], 'motorway'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_autostrade',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 4],
          'shield-autostrade-2-3',
          'shield-autostrade-4-5',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.4, 0, 7.5, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.4, 0, 7.5, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['JP:E', '首都高速道路', 'JP:expressway'],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_jp-expressway',
      layout: {
        'icon-image': 'shield-rectangle-jp',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['get', 'shield_text'],
        'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
        'text-letter-spacing': -0.03,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
      },
      minzoom: 8,
      paint: {
        'text-color': 'hsl(0, 0%, 100%)',
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['==', ['get', 'network'], 'KR:expressway'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_kr-expressway',
      layout: {
        'icon-image': [
          'case',
          ['==', ['length', ['get', 'shield_text']], 3],
          'shield-KR:expressway-long',
          'shield-KR:expressway',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'Arab Mashreq International Road Network',
            'Arab_Mashreq_International_Road_Network',
          ],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_mashreq',
      layout: {
        'icon-image': 'shield-mashreq',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['md:national', 'RO:DN', 'RO:national'],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['<=', ['length', ['get', 'shield_text']], 3],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_md',
      layout: {
        'icon-image': [
          'case',
          ['in', 'R', ['get', 'shield_text']],
          'shield-HU:national',
          ['in', 'M', ['get', 'shield_text']],
          'shield-md:national',
          ['match', ['get', 'network'], ['RO:DN', 'RO:national'], true, false],
          'shield-md:national',
          'shield-rectangle-white',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['MX:MEX', 'MEX', 'MX:MX', 'MX'],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_mx',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 2],
          'shield-MX-Federal-1-2',
          'shield-MX-Federal-3-4',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['MY:E', 'my:federal', 'MY:Federal'],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_my',
      layout: {
        'icon-image': 'shield-MY',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['match', ['get', 'network'], ['na', 'na:national'], true, false],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_na',
      layout: {
        'icon-image': 'shield-na',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(41, 94%, 68%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'case',
          ['in', 'NL:S', ['get', 'network']],
          true,
          ['==', ['get', 'network'], 'NL:NL'],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_nl-s-road',
      layout: {
        'icon-image': 'shield-NL-ring',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Regular,Noto Sans Regular'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 11,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 11.6, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 11.5, 0, 11.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['==', ['get', 'all_route_types'], 3],
        ['in', 'US:', ['get', 'network']],
        ['!=', ['get', 'network'], 'US:US'],
        ['<=', ['length', ['get', 'shield_text']], 3],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_us-state',
      layout: {
        'icon-image': 'shield-US-state',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
        'text-transform': 'uppercase',
      },
      minzoom: 9,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['in', 'VE:T', ['get', 'network']],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_ve',
      layout: {
        'icon-image': 'shield-VE:T',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['za:national', 'ls:national'],
          true,
          false,
        ],
        ['has', 'kind_detail'],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_blue-pentagon',
      layout: {
        'icon-image': [
          'case',
          ['>=', ['length', ['get', 'shield_text']], 3],
          'shield-blue-pentagon-long',
          'shield-blue-pentagon',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-max-width': 3,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 9, 12, 11],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(41, 94%, 68%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['PY:national', 'CL:national'],
          true,
          false,
        ],
        ['<=', ['length', ['get', 'shield_text']], 3],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_green-square-kite',
      layout: {
        'icon-image': 'shield-green-square-kite',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-offset': [0, 0.1],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['==', ['get', 'all_route_types'], 2],
        [
          'match',
          ['get', 'network'],
          [
            'co:national',
            'US:US',
            'US:AK',
            'US:AL',
            'US:AR',
            'US:AZ',
            'US:CA',
            'US:CO',
            'US:CT',
            'US:DE',
            'US:FL',
            'US:GA',
            'US:HI',
            'US:IA',
            'US:ID',
            'US:IL',
            'US:IN',
            'US:KS',
            'US:KY',
            'US:LA',
            'US:MA',
            'US:MD',
            'US:ME',
            'US:MI',
            'US:MN',
            'US:MO',
            'US:MS',
            'US:MT',
            'US:NC',
            'US:ND',
            'US:NE',
            'US:NH',
            'US:NJ',
            'US:NM',
            'US:NV',
            'US:NY',
            'US:OH',
            'US:OK',
            'US:OR',
            'US:PA',
            'US:RI',
            'US:SC',
            'US:SD',
            'US:TN',
            'US:TX',
            'US:UT',
            'US:VA',
            'US:VT',
            'US:WA',
            'US:DC',
            'US:WI',
            'US:WV',
            'US:WY',
          ],
          true,
          false,
        ],
        ['<=', ['length', ['get', 'shield_text']], 3],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_white-square-kite',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 2],
          'shield-US-Hwy-1-2',
          'shield-US-Hwy-3',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.8, 0, 7.9, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          ['PE:national', 'pe:national', 'PE:PE'],
          true,
          false,
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_white-red-square-kite',
      layout: {
        'icon-image': 'shield-white-red-square-kite',
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['step', ['zoom'], ['!=', ['get', 'kind_detail'], 'primary'], 9, true],
        ['==', ['get', 'network'], 'EC:provincial'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_green-red-kite',
      layout: {
        'icon-image': [
          'case',
          ['>=', ['length', ['get', 'shield_text']], 4],
          'shield-green-red-kite-long',
          'shield-green-red-kite',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        ['match', ['get', 'network'], ['US:I', 'EC:national'], true, false],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_blue-red-kite',
      layout: {
        'icon-image': [
          'case',
          ['==', ['length', ['get', 'shield_text']], 3],
          'shield-blue-red-kite-3',
          'shield-blue-red-kite',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
        'text-color': 'hsl(0, 0%, 100%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.3, 0, 7.4, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'AE',
            'AE:E-route',
            'BAB',
            'BR',
            'ch:national',
            'CN:expressway',
            'CR:CR',
            'cy:national',
            'DE:BAB',
            'Emirates routes',
            'HU:national',
            'JP:JP',
            'JP:national',
            'JP:prefectural',
            'KR:national',
            'NL:binnenstedelijke_ring',
            'PH:E',
            'PK:national',
            'PK:motorway',
            'SA:national',
            'sadc',
            'Qatar motorways',
            'TR:motorway',
            'TW:expressway',
            'TW:freeway',
            'TW:provincial',
            'UY',
            'ZM-roads',
          ],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_network',
      layout: {
        'icon-image': [
          'case',
          ['>=', ['length', ['get', 'shield_text']], 5],
          ['concat', 'shield-', ['get', 'network'], '-long'],
          ['concat', 'shield-', ['get', 'network']],
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'icon-text-fit-padding': [0, 10, 0, 10],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': [
          'case',
          ['in', 'PK:national', ['get', 'network']],
          ['to-string', ['get', 'ref']],
          ['in', 'PK:motorway', ['get', 'network']],
          ['to-string', ['get', 'ref']],
          ['to-string', ['get', 'shield_text']],
        ],
        'text-font': [
          'match',
          ['get', 'network'],
          [
            'AE',
            'AE:E-route',
            'HU:national',
            'JP:JP',
            'JP:national',
            'JP:prefectural',
            'Emirates routes',
            'Qatar motorways',
          ],
          ['literal', ['Amazon Ember Condensed RC Bold,Noto Sans Bold']],
          ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
        ],
        'text-line-height': 1,
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
        'text-transform': 'uppercase',
      },
      minzoom: 7,
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
        'text-color': [
          'case',
          [
            'match',
            ['get', 'network'],
            [
              'BAB',
              'DE:BAB',
              'HU:national',
              'JP:JP',
              'JP:national',
              'JP:prefectural',
              'KR:national',
              'PK:national',
              'PK:motorway',
              'ch:national',
              'CN:expressway',
              'Qatar motorways',
              'sadc',
              'TW:expressway',
              'TW:provincial',
              'UY',
            ],
            true,
            false,
          ],
          'hsl(0, 0%, 100%)',
          [
            'match',
            ['get', 'network'],
            ['AE', 'AE:E-route', 'cy:national', 'Emirates routes'],
            true,
            false,
          ],
          'hsl(41, 94%, 68%)',
          'hsl(0, 0%, 25%)',
        ],
        'text-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.8,
          0,
          7.9,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          10.95,
          ['case', ['==', ['get', 'kind_detail'], 'primary'], 0, 1],
          11,
          1,
        ],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'case',
          ['has', 'is_link'],
          false,
          ['!', ['has', 'shield_text']],
          false,
          ['in', ';', ['get', 'shield_text']],
          false,
          ['!', ['has', 'network']],
          false,
          ['!=', ['geometry-type'], 'LineString'],
          false,
          true,
        ],
        [
          'match',
          ['get', 'network'],
          [
            'AR:AR',
            'AR:national',
            'AU:NT:NR',
            'AU:QLD:NR',
            'AU:VIC:NR',
            'AU:WA:NR',
            'PH:N',
          ],
          true,
          false,
        ],
        [
          'step',
          ['zoom'],
          ['match', ['get', 'kind_detail'], ['motorway', 'trunk'], true, false],
          11,
          [
            'match',
            ['get', 'kind_detail'],
            ['motorway', 'trunk', 'primary', 'secondary'],
            true,
            false,
          ],
        ],
        ['has', 'kind_detail'],
        ['==', ['geometry-type'], 'LineString'],
      ],
      id: 'shield_white-kite',
      layout: {
        'icon-image': [
          'case',
          ['<=', ['length', ['get', 'shield_text']], 2],
          'shield-kite-white',
          'shield-kite-white-long',
        ],
        'icon-rotation-alignment': 'viewport',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1],
        'symbol-placement': 'line',
        'symbol-spacing': 700,
        'text-field': ['to-string', ['get', 'shield_text']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-rotation-alignment': 'viewport',
        'text-size': ['interpolate', ['linear'], ['zoom'], 7, 8, 12, 10],
      },
      minzoom: 7,
      paint: {
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
        'text-color': 'hsl(0, 0%, 25%)',
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.6, 1],
      },
      source: 'aws',
      'source-layer': 'roads',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'all',
          ['!=', ['get', 'kind'], 'unrecognized_region'],
          ['==', ['get', 'kind'], 'region'],
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'adminlabel_region',
      layout: {
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-field': [
          'step',
          ['zoom'],
          ['get', 'name:short'],
          4,
          ['coalesce', ['get', 'name:en'], ['get', 'name']],
        ],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-letter-spacing': [
          'interpolate',
          ['linear'],
          ['zoom'],
          3.75,
          0.25,
          6.5,
          0.3,
        ],
        'text-line-height': 1,
        'text-max-width': 8,
        'text-size': ['interpolate', ['linear'], ['zoom'], 4, 11, 6, 14, 8, 18],
        'text-transform': 'uppercase',
      },
      maxzoom: 8,
      minzoom: 3.75,
      paint: {
        'text-color': 'hsl(0, 0%, 93%)',
        'text-halo-color': 'hsla(60, 1%, 22%, 0.9)',
        'text-halo-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          3,
          0.75,
          6,
          1.5,
        ],
      },
      source: 'aws',
      'source-layer': 'places',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'step',
          ['zoom'],
          [
            'match',
            ['get', 'kind_detail'],
            ['city', 'locality', 'town', 'village', 'hamlet', 'borough'],
            true,
            true,
          ],
          10,
          [
            'match',
            ['get', 'kind'],
            ['neighbourhood', 'borough', 'macrohood'],
            true,
            true,
          ],
        ],
        [
          'all',
          [
            'match',
            ['get', 'kind'],
            ['unrecognized_locality', 'unrecognized_borough'],
            true,
            true,
          ],
          [
            'match',
            ['get', 'kind'],
            ['neighbourhood', 'borough', 'macrohood'],
            true,
            true,
          ],
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'placelabel_locality_settlement_small',
      layout: {
        'symbol-sort-key': ['get', 'min_zoom'],
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-line-height': 1,
        'text-max-width': 4,
        'text-padding': 40,
        'text-size': ['interpolate', ['linear'], ['zoom'], 12, 11, 15, 15],
        'text-transform': 'uppercase',
      },
      maxzoom: 16,
      minzoom: 6,
      paint: {
        'text-color': 'hsl(0, 0%, 100%)',
        'text-halo-blur': 0.75,
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': 1.25,
      },
      source: 'aws',
      'source-layer': 'places',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'match',
          ['get', 'kind_detail'],
          ['city', 'locality', 'town', 'village', 'hamlet'],
          true,
          false,
        ],
        [
          'all',
          ['!=', ['get', 'kind'], 'unrecognized_locality'],
          ['==', ['get', 'kind'], 'locality'],
        ],
        ['<', ['get', 'population'], 1000000],
        [
          'step',
          ['zoom'],
          ['>=', ['get', 'population'], 500],
          8,
          ['>=', ['get', 'population'], 350],
          10,
          ['>=', ['get', 'population'], 1000],
          11,
          ['>=', ['get', 'population'], 500],
          12,
          ['>=', ['get', 'population'], 1000],
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'placelabel_locality_settlement',
      layout: {
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Medium,Noto Sans Medium'],
        'text-justify': 'auto',
        'text-line-height': 1,
        'text-padding': 8,
        'text-radial-offset': 0.1,
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          9,
          11,
          10,
          ['case', ['>=', ['get', 'population'], 200], 13, 11],
          11,
          [
            'case',
            ['>=', ['get', 'population'], 200],
            14,
            ['>=', ['get', 'population'], 100],
            13,
            ['>=', ['get', 'population'], 50],
            12,
            11,
          ],
          14,
          ['case', ['>=', ['get', 'population'], 200], 15, 13],
        ],
        'text-variable-anchor': [
          'step',
          ['zoom'],
          [
            'literal',
            ['bottom', 'bottom-right', 'bottom-left', 'top-left', 'top-right'],
          ],
          8,
          ['literal', ['center']],
        ],
      },
      maxzoom: 16,
      minzoom: 7,
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          3,
          1,
          8.5,
          1,
          9,
          0,
        ],
        'text-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          'hsl(0, 0%, 100%)',
          12.5,
          'hsl(0, 0%, 100%)',
          15,
          'hsl(0, 0%, 100%)',
        ],
        'text-halo-blur': 0.25,
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': [
          'case',
          ['>=', ['get', 'population'], 10000],
          1.25,
          1,
        ],
      },
      source: 'aws',
      'source-layer': 'places',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'all',
          ['!=', ['get', 'kind'], 'unrecognized_locality'],
          ['==', ['get', 'kind'], 'locality'],
        ],
        [
          'step',
          ['zoom'],
          ['>=', ['get', 'population'], 1200000],
          4,
          ['>=', ['get', 'population'], 400000],
          6,
          ['>=', ['get', 'population'], 200000],
          7,
          ['>=', ['get', 'population'], 100000],
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'placelabel_locality_city',
      layout: {
        'icon-anchor': [
          'case',
          ['>=', ['get', 'population'], 1200000],
          'top',
          'center',
        ],
        'icon-image': [
          'step',
          ['zoom'],
          ['case', ['has', 'country_capital'], 'citydot-open', 'citydot'],
          8,
          [
            'case',
            [
              'all',
              ['has', 'country_capital'],
              ['>', ['get', 'population'], 100000],
            ],
            'citydot-open',
            [
              'all',
              ['has', 'country_capital'],
              ['==', ['get', 'population'], 100000],
            ],
            'citydot-open_lowrank',
            ['>', ['get', 'population'], 100000],
            'citydot',
            'citydot_lowrank',
          ],
        ],
        'symbol-sort-key': ['*', -1, ['get', 'population']],
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': [
          'step',
          ['zoom'],
          ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
          4,
          [
            'case',
            ['>=', ['get', 'population'], 1200000],
            ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
            ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
          ],
          6,
          [
            'case',
            ['>=', ['get', 'population'], 400000],
            ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
            ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
          ],
          8,
          [
            'case',
            ['>=', ['get', 'population'], 400000],
            ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
            ['>=', ['get', 'population'], 200000],
            ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
            ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
          ],
          9,
          [
            'case',
            ['>=', ['get', 'population'], 400000],
            ['literal', ['Amazon Ember Bold,Noto Sans Bold']],
            ['literal', ['Amazon Ember Medium,Noto Sans Medium']],
          ],
        ],
        'text-justify': 'auto',
        'text-line-height': 1,
        'text-radial-offset': [
          'case',
          ['>=', ['get', 'population'], 1200000],
          0.4,
          0.6,
        ],
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          4,
          ['case', ['>=', ['get', 'population'], 5000000], 11, 10],
          6,
          [
            'case',
            ['>=', ['get', 'population'], 5000000],
            15,
            ['>=', ['get', 'population'], 1000000],
            13,
            10,
          ],
          8,
          [
            'case',
            ['>=', ['get', 'population'], 5000000],
            17,
            ['>=', ['get', 'population'], 1000000],
            15,
            ['>=', ['get', 'population'], 200000],
            13,
            11,
          ],
          10,
          [
            'case',
            ['>=', ['get', 'population'], 5000000],
            21,
            ['>=', ['get', 'population'], 1000000],
            19,
            ['>=', ['get', 'population'], 200000],
            17,
            12,
          ],
          13,
          [
            'case',
            ['>=', ['get', 'population'], 5000000],
            23,
            ['>=', ['get', 'population'], 1000000],
            21,
            ['>=', ['get', 'population'], 200000],
            19,
            14,
          ],
        ],
        'text-variable-anchor': [
          'step',
          ['zoom'],
          [
            'literal',
            ['bottom', 'bottom-right', 'bottom-left', 'top-left', 'top-right'],
          ],
          9,
          ['literal', ['center']],
        ],
      },
      maxzoom: 14,
      minzoom: 3,
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          3,
          1,
          8.5,
          1,
          9,
          0,
        ],
        'text-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          6,
          'hsl(0, 0%, 100%)',
          8,
          [
            'case',
            ['>', ['get', 'population'], 100000],
            'hsl(0, 0%, 100%)',
            'hsl(0, 0%, 100%)',
          ],
          9,
          [
            'case',
            ['>', ['get', 'population'], 100000],
            'hsl(0, 0%, 100%)',
            'hsl(0, 0%, 100%)',
          ],
          12.49,
          'hsl(0, 0%, 100%)',
          12.5,
          'hsl(0, 0%, 100%)',
        ],
        'text-halo-blur': [
          'interpolate',
          ['linear'],
          ['zoom'],
          6,
          0.5,
          8,
          ['case', ['>=', ['get', 'population'], 1200000], 2, 0.5],
        ],
        'text-halo-color': 'hsl(60, 33%, 9%)',
        'text-halo-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          6,
          1.2,
          8,
          ['case', ['>=', ['get', 'population'], 1200000], 1.75, 1.3],
        ],
      },
      source: 'aws',
      'source-layer': 'places',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        [
          'all',
          ['!=', ['get', 'kind'], 'unrecognized_country'],
          ['==', ['get', 'kind'], 'country'],
        ],
        [
          'step',
          ['zoom'],
          ['<=', ['get', 'min_zoom'], 1],
          2,
          ['<=', ['get', 'min_zoom'], 3],
          3,
          ['!', ['in', ['get', 'iso_code'], ['literal', ['MB', 'UN']]]],
          7,
          true,
        ],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'adminlabel_country',
      layout: {
        'symbol-sort-key': ['-', 20, ['get', 'population_rank']],
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Bold,Noto Sans Bold'],
        'text-letter-spacing': 0.2,
        'text-line-height': 1,
        'text-max-width': 8,
        'text-padding': 3,
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          1,
          7,
          2,
          8.5,
          4,
          11,
          5,
          12,
          6,
          15,
        ],
        'text-transform': 'uppercase',
      },
      maxzoom: 8,
      minzoom: 1,
      paint: {
        'text-color': 'hsl(0, 0%, 98%)',
        'text-halo-blur': 1,
        'text-halo-color': 'hsla(60, 3%, 18%, 0.9)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'places',
      type: 'symbol',
    },
    {
      filter: [
        'all',
        ['==', ['get', 'kind'], 'continent'],
        ['==', ['geometry-type'], 'Point'],
      ],
      id: 'adminlabel_continent',
      layout: {
        'text-field': ['coalesce', ['get', 'name:en'], ['get', 'name']],
        'text-font': ['Amazon Ember Condensed RC Regular,Noto Sans Regular'],
        'text-letter-spacing': 0.2,
        'text-line-height': 1,
        'text-padding': 3,
        'text-size': 14,
        'text-transform': 'uppercase',
      },
      maxzoom: 2,
      minzoom: 0,
      paint: {
        'text-color': 'hsl(0, 0%, 98%)',
        'text-halo-blur': 1,
        'text-halo-color': 'hsla(60, 3%, 18%, 0.9)',
        'text-halo-width': 2,
      },
      source: 'aws',
      'source-layer': 'earth',
      type: 'symbol',
    },
  ],
  created: '0001-01-01T00:00:00Z',
  modified: '0001-01-01T00:00:00Z',
  id: 'hybrid-global-light-default-2.1.0',
});
